import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import { Footer } from "./Footer";
import { Header } from "./Header";

type HeaderNFooterProps = {
  cx: string;
};

export const HeaderNFooter: React.FC<HeaderNFooterProps> = ({
  children,
  cx,
}) => {
  const location = useLocation();
  const [isMain] = useState(
    ["/sign-in", "/sign-up"].includes(location.pathname)
  );
  return (
    <>
      {isMain && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "black",
            width: "50vw",
            height: "100vh",
            zIndex: 0,
          }}
        />
      )}
      <Header />
      <main
        style={{
          minHeight: `calc(100vh - 4.375rem - ${isMain ? 70 : 151}px)`,
        }}
        className={cx}
      >
        {children}
      </main>
      <Footer />
    </>
  );
};
